import React from "react";
import { Divider } from "shipnow-mercurio";
import { EstimatedShippingPrice } from "../../../exchanges/pages/new/components/steps/address/EstimatedShippingPrice";
import PropTypes from "prop-types";

const DEFAULT_PROPS = {
  order: null,
  shippingOptionDescription: "",
};

export const ServicePriceSAP = (props) => {
  const attrs = { ...DEFAULT_PROPS, ...props };

  if (
    !attrs.shippingOptionDescription?.name ||
    !attrs.shippingOptionDescription?.price
  ) {
    return null;
  }

  return (
    <>
      <Divider margin="y-24" />
      <EstimatedShippingPrice carrier={attrs.shippingOptionDescription} />
    </>
  );
};

ServicePriceSAP.propTypes = {
  order: PropTypes.object,
  shippingOptionDescription: PropTypes.string,
};
